import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

export default function DetailingServiceSection() {
  const packages = [
  {
    id: 'detail_basic',
    name: 'DETAILING BÁSICO',
    duration: '3-4 horas',
    includes: [
    'Lavado exterior completo',
    'Limpieza de llantas y neumáticos',
    'Aspirado interior',
    'Limpieza de tablero y consola',
    'Limpieza de cristales']
  },
  {
    id: 'detail_premium',
    name: 'DETAILING PREMIUM',
    duration: '6-8 horas',
    includes: [
    'Todo lo anterior',
    'Pulido de pintura (corrección ligera)',
    'Limpieza profunda de tapicería',
    'Tratamiento de cuero',
    'Descontaminación de pintura',
    'Cera de protección'],
    popular: true
  },
  {
    id: 'detail_ultimate',
    name: 'DETAILING ULTIMATE',
    duration: '2-3 días',
    includes: [
    'Todo lo anterior',
    'Corrección de pintura completa',
    'Extracción de manchas profundas',
    'Restauración de faros',
    'Tratamiento de motor',
    'Desinfección con ozono',
    'Acabado con cera premium']
  }];


  return (
    <section className="py-32 px-6 lg:px-12 bg-gradient-to-b from-black via-card to-black" id="detallado">
      <div className="max-w-[1600px] mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="text-primary font-heading text-sm tracking-[0.3em] mb-4 block">
            04 / AUTO DETAILING
          </span>
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white mb-6 tracking-tight">
            REACONDICIONAMIENTO
            <br />
            <span className="text-gradient-red">ESTÉTICO COMPLETO</span>
          </h2>
          <p className="text-white/70 text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
            Restauramos tu vehículo a condición de showroom. Cada detalle importa.
          </p>
        </div>

        {/* Before/After Showcase */}
        <div className="grid lg:grid-cols-2 gap-8 mb-20">
          <div className="relative rounded-[32px] overflow-hidden border border-white/10 group">
            <AppImage
              src="https://img.rocket.new/generatedImages/rocket_gen_img_13d20344a-1770056179690.png"
              alt="Vehicle interior before detailing showing dirt and stains on seats"
              className="w-full aspect-[4/3] object-cover" />

            <div className="absolute bottom-6 left-6 z-10 bg-black/60 backdrop-blur-md px-6 py-3 rounded-full">
              <span className="text-white font-heading text-sm tracking-wider">
                ANTES
              </span>
            </div>
          </div>
          <div className="relative rounded-[32px] overflow-hidden border border-primary/30 group">
            <AppImage
              src="https://img.rocket.new/generatedImages/rocket_gen_img_12f0cfb6c-1764734283088.png"
              alt="Vehicle interior after professional detailing with pristine clean leather seats"
              className="w-full aspect-[4/3] object-cover" />

            <div className="absolute bottom-6 right-6 z-10 bg-black/60 backdrop-blur-md px-6 py-3 rounded-full border border-primary/60">
              <span className="text-white font-heading text-sm tracking-wider">
                DESPUÉS
              </span>
            </div>
          </div>
        </div>

        {/* Packages */}
        <div className="grid md:grid-cols-3 gap-8">
          {packages?.map((pkg) =>
          <div
            key={pkg?.id}
            className={`glass-card p-8 rounded-[32px] hover:bg-white/10 transition-all duration-300 relative ${
            pkg?.popular ? 'border-2 border-primary' : ''}`
            }>

              {pkg?.popular &&
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary px-6 py-2 rounded-full">
                  <span className="text-white font-heading text-xs tracking-wider">
                    MÁS SOLICITADO
                  </span>
                </div>
            }
              <h3 className="font-heading text-xl text-white mb-2 tracking-wider">
                {pkg?.name}
              </h3>
              <div className="flex items-center gap-2 text-primary text-sm font-medium mb-6">
                <Icon name="ClockIcon" size={16} variant="outline" />
                <span>{pkg?.duration}</span>
              </div>
              <ul className="space-y-3 mb-8">
                {pkg?.includes?.map((item, idx) =>
              <li
                key={`${pkg?.id}_item_${idx}`}
                className="flex items-start gap-2 text-white/70 text-sm">

                    <Icon
                  name="CheckIcon"
                  size={16}
                  variant="solid"
                  className="text-primary mt-0.5 flex-shrink-0" />

                    {item}
                  </li>
              )}
              </ul>
              <button className="w-full bg-primary hover:bg-primary/90 text-white px-6 py-4 rounded-full font-heading text-sm tracking-wider transition-all duration-300 hover:scale-105">
                RESERVAR AHORA
              </button>
            </div>
          )}
        </div>

        {/* Add-ons */}
        <div className="mt-20">
          <h3 className="font-heading text-2xl text-white text-center mb-12 tracking-wider">
            SERVICIOS ADICIONALES
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
            { id: 'addon_1', name: 'Restauración de Faros' },
            { id: 'addon_2', name: 'Pulido de Rines' },
            { id: 'addon_3', name: 'Limpieza de Motor' },
            { id: 'addon_4', name: 'Ozono Interior' }]?.
            map((addon) =>
            <div
              key={addon?.id}
              className="glass-card p-6 rounded-[24px] hover:bg-white/10 transition-all duration-300 text-center">

                <h4 className="text-white font-heading text-sm tracking-wider mb-2">
                  {addon?.name}
                </h4>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

}